<template>
    <div id="noData">
        <img class="internetSpeed" src="@/assets/images/template/bg-pic2.png"/>
        <span>{{$t("trade.noData.content")}}</span>
        <p @click="refresh">{{$t("trade.noData.reload")}}</p>
    </div>
</template>

<script>
    export default {
        name: "InternetSpeed",
        methods:{
            refresh(){
                this.$router.go(0);
            }
        }
    }
</script>
